import { EventEmitter } from 'fbemitter'

import { type EventPayload, type EventsEmitter } from './events'

const createEventEmitter = () => {
    const emitter = new EventEmitter()

    const addListener = <T extends EventsEmitter>(
        event: T,
        callback: (payload: EventPayload<T>) => void
    ) => {
        return emitter.addListener(event, callback)
    }

    const emit = <T extends EventsEmitter>(
        event: T,
        payload?: EventPayload<T>
    ) => {
        emitter.emit(event, payload)
    }

    return {
        addListener,
        emit
    }
}

export const emitter = createEventEmitter()
